import axios from "axios";
import Supplier from "@/features/Supplier/Supplier";

export class SupplierService {
    private supplierURL = "/api/v1/suppliers";

    async getSupplierFromServer(id: string): Promise<Supplier> {
        const response = await axios.get(this.supplierURL + "/" + id);
        return response.data as Supplier;
    }

    async getSuppliersFromServer(query: string, maxSuppliersToReturn: number): Promise<Supplier[]> {
        const response = await axios.get(this.supplierURL, {
            params: {
                query: query,
                maxSuppliersToReturn: maxSuppliersToReturn,
            },
        });
        return response.data as Supplier[];
    }
}
